import { TimeSheetType } from "./timeSheetType";

export const timeSheetReducer = {
  resetTimeSheetSuccess: (state: TimeSheetType) => {
    state.success = null;
  },
  resetTimeSheetError: (state: TimeSheetType) => {
    state.error = null;
  },
  resetTimeSheetMessage: (state: TimeSheetType) => {
    state.message = null;
  },
  resetTimeSheetStatusCode: (state: TimeSheetType) => {
    state.statusCode = null;
  },
  resetTimeSheetTotalTime: (state: TimeSheetType) => {
    state.totalTime = 0;
  },
  resetTimeSheetListing: (state: TimeSheetType) => {
    state.timeSheetData = [];
  },
  resetTimeSheetReportListing: (state: TimeSheetType) => {
    state.timeSheetReportDataList = [];
  },
  resetTimeSheetReportTotalCount: (state: TimeSheetType) => {
    state.timeSheetReportTotalCount = "";
  },
  resetUserTimeSheetReportSuccess: (state: TimeSheetType) => {
    state.userViewTimeSheetSuccess = null;
  },
  resetUserViewTimeSheetReportStatusCode: (state: TimeSheetType) => {
    state.userViewTimeSheetStatusCode = null;
  },
  resetUserViewTimeSheetReportError: (state: TimeSheetType) => {
    state.userViewTimeSheetError = null;
  },
  resetUserViewTimeSheetReportMessage: (state: TimeSheetType) => {
    state.userViewTimeSheetMessage = null;
  },
  resetTimeSheetReportTotalTime: (state: TimeSheetType) => {
    state.reportTotalTime = 0;
  },
  resetTimeSheetReportBillableTotalTime: (state: TimeSheetType) => {
    state.reportTotalBillableTime = 0;
  },
  resetTimeSheetReportNonBillableTotalTime: (state: TimeSheetType) => {
    state.reportTotalNonBillableTime = 0;
  },
  resetUnfilledTimesheetCount: (state: TimeSheetType) => {
    state.unfilledTimesheetCount = 0;
  },
  resetUnfilledTimesheetReportList: (state: TimeSheetType) => {
    state.unfilledTimesheetReportList = [];
  },
  resetReportForSpecificJobList: (state: TimeSheetType) => {
    state.reportForSpecificJobList = [];
  },
  resetReportForSpecificJobTotalCount: (state: TimeSheetType) => {
    state.reportForSpecificJobTotalCount = 0;
  },
  resetTotalWorkingHoursOnSpecificJob: (state: TimeSheetType) => {
    state.totalWorkingHoursOnSpecificJob = "";
  },
  resetTimeSheetSummaryReportListing: (state: TimeSheetType) => {
    state.timesheetSummaryReportList = [];
  },
  resetTimeSheetSummaryReportTotalCount: (state: TimeSheetType) => {
    state.timsheetSummaryReportTotal = "";
  },
  resetBillableSumTotal: (state: TimeSheetType) => {
    state.billableSumTotal = 0;
  },
  resetNonBillableSumTotal: (state: TimeSheetType) => {
    state.nonBillableSumTotal = 0;
  },
  resetTotalHoursSumTotal: (state: TimeSheetType) => {
    state.totalHoursSumTotal = 0;
  },
  resetEmployeeWithoutFillTimesheetList: (state: TimeSheetType) => {
    state.employeeWithoutFillTimesheetList = [];
  },
  resetEmployeeWithoutFillTimesheetCount: (state: TimeSheetType) => {
    state.employeeWithoutFillTimesheetCount = 0;
  },
  resetTimeSheetReportCalenderDataList: (state: TimeSheetType) => {
    state.timeSheetReportCalenderDataList = [];
  },
  resetAllUserAttendanceReportList: (state: TimeSheetType) => {
    state.allUserAttendanceReportList = [];
  },
  resetSingleAttendaceReportList: (state: TimeSheetType) => {
    state.attendanceReportList = [];
  },
  resetSingleAttendanceDetail: (state: TimeSheetType) => {
    state.singleAttendanceDetail = {};
  },
  resetAttendanceReportListCount: (state: TimeSheetType) => {
    state.reportListCount = 0;
  },
  resetTimesheetVsSchedulingMonthlyList: (state: TimeSheetType) => {
    state.timesheetVsSchedulingMonthlyList = [];
  },
  resetTimesheetVsSchedulingMonthlyTotalCount: (state: TimeSheetType) => {
    state.timesheetVsSchedulingMonthlyTotalCount = 0;
  },
  resetClientWiseUserTimeSheetList: (state: TimeSheetType) => {
    state.clientWiseUserTimeSheetList = { billable_sum: 0, count: 0, data: [] };
  },
  resetClientWiseMonthlyReportCount: (state: TimeSheetType) => {
    state.clientWiseMonthlyReportCount = 0;
  },
  resetClientWiseMonthlyTimesheetReportList: (state: TimeSheetType) => {
    state.clientWiseMonthlyTimesheetReportList = [];
  },
  resetMonthWiseTimesheetReportTotalCount: (state: TimeSheetType) => {
    state.monthWiseTimesheetReportTotalCount = 0;
  },
  resetMonthWiseTimesheetReportList: (state: TimeSheetType) => {
    state.monthWiseTimesheetReportList = [];
  },
  resetTimesheetReportTargetHours:(state:TimeSheetType)=>{
    state.timesheetReportTargetHours=0;
  },
  resetOpenJobChargedHoursTimesheetList: (state: TimeSheetType) => {
    state.openJobChargedHoursTimesheetList = [];
  },
  resetOpenJobChargedHoursTimesheetTotalSum:(state:TimeSheetType)=>{
    state.openJobChargedHoursTimesheetTotalSum=0;
  },
  resetEnableBackdatedTimesheetEntry:(state:TimeSheetType)=>{
    state.enableBackdatedTimesheetEntry=false;
  }
};
